import React, { memo, useState } from 'react';
import cx from 'classnames';
import type { ImageItem } from '../useImageUpload';
import styles from './index.module.less';
import { Image } from 'antd';

interface ImagePreviewProps {
    imageList: ImageItem[];
    isMaxCount: boolean;
    onAdd: () => void;
    onRemove: (id: string) => void;
    onRetry: (item: ImageItem) => void;
}

const delImg = 'https://med-fe.cdn.bcebos.com/fe-doctor-workbench/%E5%88%A0%E9%99%A4-icon.png';
const failedImg = 'https://med-fe.cdn.bcebos.com/fe-doctor-workbench/failed.png';

/**
 * 图片预览区域组件
 * 展示缩略图列表 + 添加按钮
 */
const ImagePreview: React.FC<ImagePreviewProps> = memo(({ imageList, isMaxCount, onAdd, onRemove, onRetry }) => {
    const [previewVisible, setPreviewVisible] = useState(false);
    const [previewIndex, setPreviewIndex] = useState(0);

    if (imageList.length === 0) return null;

    return (
        <div className={styles.imagePreviewArea}>
            {imageList.map((item, index) => (
                <div
                    key={item.id}
                    className={styles.thumbnailWrapper}
                    onClick={() => {
                        setPreviewIndex(index);
                        setPreviewVisible(true);
                    }}
                >
                    <Image
                        src={item.url}
                        preview={false}
                        className={cx(styles.thumbnail, {
                            [styles.uploading]: item.uploadStatus === 'uploading',
                            [styles.failed]: item.uploadStatus === 'failed',
                        })}
                    />
                    {/* 上传中遮罩 */}
                    {item.uploadStatus === 'uploading' && (
                        <div className={styles.uploadingMask}>
                            <div className={styles.loadingSpinner} />
                        </div>
                    )}
                    {/* 上传失败遮罩 */}
                    {item.uploadStatus === 'failed' && (
                        <div
                            className={styles.failedMask}
                            onClick={(e) => {
                                e.stopPropagation();
                                onRetry(item);
                            }}
                        >
                            <img src={failedImg} width={20} height={20} alt="" />
                            <span>重新上传</span>
                        </div>
                    )}
                    {/* 删除按钮 */}
                    <button
                        className={styles.deleteBtn}
                        onClick={(e) => {
                            e.stopPropagation();
                            onRemove(item.id);
                        }}
                    >
                        <img src={delImg} width={14} height={14} alt="" />
                    </button>
                </div>
            ))}

            <Image.PreviewGroup
                items={imageList.map((item) => item.url)}
                preview={{
                    visible: previewVisible,
                    current: previewIndex,
                    onChange: setPreviewIndex,
                    onVisibleChange: setPreviewVisible,
                }}
            />

            {/* 添加按钮 */}
            {!isMaxCount && (
                <button className={styles.addBtn} onClick={onAdd}>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M10 4V16M4 10H16" stroke="#bbb" strokeWidth="2.5" strokeLinecap="round" />
                    </svg>
                </button>
            )}
        </div>
    );
});

export default ImagePreview;
